export default {
  Register: 'הרשמה',
  'Full name': 'שם מלא',
  'Confirm Password': 'אימות סיסמה',
  'I want to process this payment without enhanced authentication (verification code sent to the card owner) and I consent that I am responsible for this payment.':
    'אני מעוניין לחייב עסקה זו ללא אימות מוגבר (קוד אימות הנשלח לבעל הכרטיס) ואני מאשר שהאחריות על תשלום עסקה זו תחול עליי.',
  Download: 'הורדה',
  'Only missing HCN': 'ללא HCN',
  'Filter Reservations By': 'חיפוש הזמנות',
  'Filter Vouchers By': 'חיפוש שוברים',
  'Advanced search': 'חיפוש מתקדם',
  'Close advanced search': 'סגור חיפוש מתקדם',
  'Reservation id': 'מספר הזמנה',
  'Supplier name': 'שם ספק',
  'Filter date by': 'סנן תאריך לפי',
  'Check-in date': 'תאריך הגעה',
  'Creation date': 'תאריך יצירת ההזמנה',
  Till: 'עד-',
  'Customer name': 'שם לקוח',
  'Customer phone': 'טלפון לקוח',
  'Customer email': 'מייל לקוח',
  'Agent id': 'מספר סוכן',
  'Supplier booking id': 'מספר הזמנה של הספק',
  'Set hotel confirmation number': 'הכנס HCN',
  'Enter hotel confirmation number': 'הכנס מספר אישור',
  'Hotel confirmation number': 'מספר אישור המלון',
  'Supplier confirmation number': 'מספר אישור הספק',
  'All Reservations': 'כל ההזמנות',
  Supplier: 'ספק',
  Cancun: 'קנקון',
  Barcelona: 'ברצלונה',
  Amsterdam: 'אמסטרדם',
  Berlin: 'ברלין',
  Dubai: 'דובאי',
  Travelor: 'טרוולאור',
  Navigation: 'ניווט',
  Back: 'חזור',
  'You are online': 'החיבור לאינטרנט התחדש.',
  'You are offline': 'החיבור לאינטרנט נותק.',
  'Reservation Management': 'ניהול הזמנה',
  Dashboard: 'לוח בקרה',
  'My Reservations': 'ההזמנות שלי',
  'My Account': 'החשבון שלי',
  'Favorites Hotels': 'מלונות מועדפים',
  'Recent Searches': 'חיפושים אחרונים',
  'My Coupons': 'השוברים שלי',
  Status: 'סטטוס',
  created: 'התחילה',
  initialized: 'ממתינה',
  confirmed: 'אושרה',
  completed: 'הושלמה',
  cancelled: 'בוטלה',
  failed: 'נכשלה',
  error: 'שגיאה',
  rejected: 'נדחתה',
  active: 'פעיל',
  expired: 'פג תוקף',
  review: 'ממתינה',
  fraud: 'ממתינה',
  blocked: 'ממתינה',
  requested: 'ממתינה',
  'pending-refund': 'בתהליך ביטול',
  'pending-cancellation': 'ממתינה לביטול',
  'error-cancellation': 'ממתינה לביטול',
  'cancelled-with-fees': 'בוטלה',
  frozen: 'הוקפאה',
  'frozen-with-fees': 'הוקפאה',
  pending: 'ממתינה',
  'pending-payment': 'ממתינה לתשלום',
  incomplete: 'ממתינה',
  Type: 'סוג',
  flight: 'טיסה',
  ticket: 'כרטיס לאירוע',
  car: 'השכרת רכב',
  package: 'חבילת נופש',
  Country: 'מדינה',
  Landmarks: 'ציוני דרך',
  Restaurants: 'מסעדות',
  Tax: 'מס',
  VAT: 'מע"מ',
  'Split Fee': 'עמלת פיצול',
  Markup: 'עמלה',
  Valid: 'בתוקף',
  Expired: 'פג תוקף',
  'Coupon code': 'קוד קופון',
  Balance: 'יתרה',
  Update: 'עדכון',
  'the hotel': 'למלון',
  'the airline': 'אל חברת התעופה',
  'the service provider': 'אל ספק השירות',
  'Successfully sent.': 'נשלח בהצלחה.',
  'Successfully updated.': 'עודכן בהצלחה.',
  'Successfully canceled.': 'בוטל בהצלחה.',
  'The images are for illustration only and may not fully represent the room features you have selected.':
    'התמונות להמחשה בלבד וייתכן שאינן מייצגות באופן מלא את תכונות החדר שבחרת.',
  'The process was successful': 'התהליך עבר בהצלחה',
  'Your booking has been successfully canceled': 'הזמנתך בוטלה בהצלחה',
  'How would you like to receive a refund for this booking?':
    'כיצד תרצה לקבל החזר עבור הזמנה זו?',
  'Give me a coupon code for': 'צרו לי קוד קופון על סך',
  'Hey, you received a coupon': 'הי, קיבלת קופון',
  'You already have voucher we will refund it, the code is':
    'כבר יש לך שובר נמלא  לך אותו, הקוד שלו הוא',
  'with this amount': 'בסכום זה',
  'Hey, we have renewed the coupon for you': 'הי, חידשנו לך את הקופון',
  'Its code': 'הקוד שלו',
  'Credit my credit card': 'זכו לי את כרטיס האשראי',
  "Iֿֿ'll decide later": 'אחליט מאוחר יותר',
  'Special Request': 'בקשות מיוחדות',
  'Special requests for this room': 'בקשות מיוחדות לחדר זה',
  'Please write your requests in English. Special requests are not guaranteed - but the hotel will do its best to fulfill your needs.':
    'אנא כתבו את בקשותיכם באנגלית. בקשות מיוחדות אינן מובטחות - אך המלון יעשה כמיטב יכולתו למלא אחר צרכיכם.',
  'City tax': 'מס עירוני',
  'Mandatory tax': 'מס חובה',
  'mandatory tax': 'מס חובה',
  'mandatory fee': 'מס חובה',
  'resort fee': 'היטל נופש',
  'service charge': 'עמלת שירות',
  'electricity fee': 'היטל חשמל',
  TaxAndServiceFee: 'מיסים ועמלות',
  'tax and service fee': 'מיסים ועמלות',
  'Your commission': 'העמלה שלך',
  Included: 'כלול',
  'Not Included - Collected by property': 'לא כלול - תשלום במלון',
  'Have a Coupon?': 'יש לך קופון?',
  'Coupon Code': 'קוד קופון',
  'Have a payment voucher?': 'יש לך שובר תשלום?',
  'Voucher Code': 'קוד שובר',
  'My Vouchers': 'השוברים שלי',
  'Created at': 'נוצר בתאריך',
  'Reservation no.': 'מספר הזמנה',
  'No voucher redemptions found': 'לא נמצאו מימושים לקופון',
  'Balance to redeem': 'יתרה למימוש',
  'Last week': 'שבוע שעבר',
  'Last month': 'חודש שעבר',
  'Between dates': 'בין תאריכים',
  'You have a balance of {amount} to redeem in this reservation. Would you like to get a coupon?':
    'יש לך יתרה של {amount} למימוש בהזמנה זו. האם תרצה לקבל קופון?',
  Amount: 'סכום',
  code: 'קוד',
  'My redemptions': 'המימושים שלי',
  Hide: 'הסתר',
  Discount: 'הנחה',
  'Create payment voucher': 'יצירת שובר תשלום',
  'Payment voucher': 'שובר תשלום',
  'Payment voucher issued': 'הופק שובר תשלום ',
  'Payment voucher redeemed': 'מומש שובר תשלום',
  Apply: 'החל',
  Cash: 'מזומן',
  'Bank Transfer': 'העברה בנקאית',
  Receipt: 'קבלה',
  'Total Price': 'סה"כ',
  'Total Received': 'סה"כ התקבל',
  'We converted the price to display in': 'המרנו את המחיר לתצוגה',
  'Original price': 'מחיר מקורי',
  'Reservation Summary': 'סיכום הזמנה',
  'Agent reference': 'שיוך לסוכן',
  'The site is secured by international PCI standards, the most strict standards for purchasing online.':
    'האתר מאובטח על ידי תקן PCI הבינלאומי, סטנדרט אבטחה המחמיר בעולם לרכישות באינטרנט.',
  '{distance} km': '{distance} ק"מ',
  '{distance} m': '{distance} מטר',
  "What's nearby": 'בסביבה הקרובה',
  'Getting around': 'תחבורה ציבורית',
  'min walk': 'דקות הליכה',
  'min drive': 'דקות נסיעה',
  'Hotel Facilities': 'מתקני המלון',
  'Filter rooms by': 'סינון חדרים לפי',
  'Show less': 'הצג פחות',
  'Show more': 'הצג עוד',
  'Show all': 'הצג הכל',
  'Remind Me': 'הזכירו לי',
  'On this date we will remind you to pay': 'בתאריך זה נתזכר אותך לשלם',
  "Your booking has been confirmed by the hotel, but hasn't been paid for yet. You're Confirmation number is {id}. We will send you a reminder and a link for payment on {remind_at} to your email {email}.":
    'הזמנתך אושרה מול המלון, אך עדיין לא שולמה. מספר ההזמנה הוא {id}. אנו נשלח לך תזכורת עם קישור לתשלום בתאריך {remind_at} למייל {email}.',
  "Please note! If the payment will not be received by {date} the booking will be cancelled automatically and couldn't be restored.":
    'במידה ולא יתקבל תשלום עד תאריך {date} ההזמנה תבוטל באופן אוטומטי ולא יהיה ניתן לשחזרה.',
  "Please note! If the payment will not be received by {date} the booking will be cancelled automatically and couldn't be restored. The reserve cost won't be refunded.":
    'במידה ולא יתקבל תשלום עד תאריך {date} ההזמנה תבוטל באופן אוטומטי לא יהיה ניתן לשחזרה, ולא תוחזר עלות השיריון.',
  'I confirm that the transaction price shown in {currency} is an approximate price converted from an amount of {original_price}. Any payment towards the value of the transaction price will be charged according to the exchange rate at the time of the actual payment.':
    'אני מאשר כי מחיר העסקה המוצג ב-{currency} הינו מחיר משוער שהומר מסך של {original_price}. כל תשלום שישולם על חשבון התמורה יחויב בהתאם לשער החליפין הידוע במועד התשלום בפועל.',
  'The transaction price shown in {currency} is an approximate price converted from an amount of {original_price}. Any payment towards the value of the transaction price will be charged according to the exchange rate at the time of the actual payment.':
    'מחיר העסקה המוצג ב-{currency} הינו מחיר משוער שהומר מסך של {original_price}. כל תשלום שישולם על חשבון התמורה יחויב בהתאם לשער החליפין הידוע במועד התשלום בפועל.',
  "If the reservation will be cancelled, the late payment cost of {payment} won't be refunded.":
    'במידה וההזמנה תבוטל, דמי השריון בסך {payment} לא יוחזרו.',
  'Note! The cost of splitting a credit card is {payment} for each additional card.':
    'שימו לב! עלות פיצול כרטיס אשראי הינו {payment} על כל כרטיס נוסף.',
  'Note! The cost of late payment is {payment}.':
    'שימו לב! עלות שריון הזמנה הינו {payment}.',
  'We are just sending your booking to the hotel and waiting for confirmation. This may take a few minutes. In the next few minutes you will receive an email regarding your booking.':
    'ברגעים אלו אנו שולחים את הזמנתך למלון וממתינים לאישורה. פעולה זו עשויה לקחת מספר דקות. בדקות הקרובות ישלח אליך מייל בנוגע להזמנתך.',
  'We are just sending your booking to {provider} and waiting for confirmation. This may take a few minutes. In the next few minutes you will receive an email regarding your booking.':
    'ברגעים אלו אנו שולחים את הזמנתך {provider} וממתינים לאישורה. פעולה זו עשויה לקחת מספר דקות. בדקות הקרובות ישלח אליך מייל בנוגע להזמנתך.',
  "Reservation {number} was not approved. Please enter a new reservation. Please note that we have reserved the amount you paid but didn't charge it. It will be cancelled automatically in a couple of days. You can enter a new reservation. If you want to use the reserve already placed to your card, please contact our customer support using our email reservations@travelor.com with your reservation number.":
    'הזמנתך מספר {number} נכשלה. אנא הכנס/י הזמנה חדשה. לתשומת ליבך, תפסנו מסגרת על הסכום ששילמת שתשתחרר אוטומטית תוך מספר ימים. באפשרותך להכניס הזמנה חדשה. אם ברצונך להשתמש במסגרת שכבר נתפסה, אנא צור קשר עם שירות הלקוחות שלנו במייל reservations@travelor.com בצירוף מספר ההזמנה שלך.',
  "Reservation {number} is awating approval. Your reservation is now managed by our customer support team for approval. Please contact us using our email reservations@travelor.com or wait for our team to contact you. Please note that we reserved the amount paid with your credit card. If your reservation wonֿֿ't be completed, the reserve will be cancelled automatically in a couple of days.":
    'הזמנתך מספר {number} ממתינה לאישור. הזמנתך עברה לטיפול שירות הלקוחות שלנו לאישורה. אנא צור איתנו קשר במייל reservations@travelor.com בצירוף ההזמנה, או המתן ששירות הלקוחות שלנו יצור איתך קשר. לתשומת ליבך, תפסנו מסגרת על הסכום ששילמת. במידה והזמנתך לא תושלם, המסגרת תשתחרר אוטומטית תוך מספר ימים.',
  'Someone has just booked this room before you. Please':
    'מישהו הקדים אותך והזמין את החדר.',
  'return to the home page': 'חזור לדף הבית',
  'Return to Hotel Page': 'חזרה לעמוד מלון',
  'Return to {name}': 'חזרה אל {name}',
  "Someone's just booked that room and we can't complete your reservation.":
    'מישהו בדיוק הזמין את החדר הזה ולכן אנחנו לא יכולים להשלים את ההזמנה שלך.',
  'We apologize for the inconvenience': 'אנו מתנצלים על אי הנוחות',
  'Hey, are you still there?': 'היי, אתם עדיין כאן?',
  "You've been inactive for 30 minutes so your search results have expired.":
    'לא הייתם פעילים באתר במשך 30 דקות ולכן תוצאות החיפוש כבר לא מעודכנות.',
  'Hit refresh to see the latest hotel prices.':
    'ליחצו על "רענון הדף" בכדי לראות את מחירי המלונות העדכניים.',
  'and restart your booking process.': 'ונסה לבצע הזמנה זו מחדש',
  'Payments Received': 'תשלומים שהתקבלו',
  'Full Name': 'שם מלא',
  'Payment Amount': 'סכום לתשלום',
  'Balance Due': 'יתרה לתשלום',
  'Receipt details': 'פרטי קבלה',
  'Multiple credit cards': 'מספר כרטיסי אשראי',
  'Single credit card': 'כרטיס אשראי אחד',
  'Credit Card Details': 'פרטי כרטיס אשראי',
  'Reservation Number': 'מספר הזמנה',
  'Cancellation Deadline': 'תאריך אחרון לביטול',
  'Create Date': 'תאריך יצירה',
  'Future payment': 'תשלום עתידי',
  'Offset from my wallet': 'קיזוז מהארנק שלי',
  'Select your payment option': 'בחר אפשרות תשלום',
  Customer: 'לקוח',
  Book: 'הזמן',
  Clear: 'נקה',
  'Payment details': 'פרטי תשלום',
  'Payment type': 'סוג תשלום',
  'Card number': 'מספר כרטיס',
  'Payments number': 'מספר תשלומים',
  'View invoice': 'צפיה בקבלה',
  'View your voucher': 'צפייה בשובר שלך',
  'Cancel Booking': 'ביטול הזמנה',
  'Shere us with your cancel reason': 'שתף אותנו עם סיבת הביטול שלך',
  "I don't want to cancel": 'אני לא רוצה לבטל',
  'Are you sure you want to cancel this booking?':
    'האם אתה בטוח שברצונך לבטל הזמנה זו?',
  'It will not be possible to restore the booking':
    'לא תהיה אפשרות לשחזר את ההזמנה',
  'I have made several bookings for those dates and I want to cancel what is not needed':
    'ביצעתי מספר הזמנות לאותם תאריכים ואני רוצה לבטל מה שאין צורך בהן',
  'I found another accommodation': 'מצאתי מקום אירוח אחר',
  'Personal reasons / trip canceled': 'סיבות אישיות / הנסיעה בוטלה',
  'Change in the number or needs of the guests': 'שינוי במספר או בצרכי האורחים',
  'None of the above options': 'אף אחת מהאפשרויות לעיל',
  'Are you sure you want to book this reservation?':
    'האם אתה בטוח שברצונך לשריין הזמנה זו?',
  'No reservations found': 'לא נמצאו הזמנות',
  'More room info': 'מידע נוסף על החדר',
  'Load More': 'טען עוד',
  'The ': 'ה',
  'Best Hotel': 'מלון הטוב ביותר',
  'Best Apartment': 'דירה הטובה ביותר',
  'Best Hostel': 'אכסניה הטובה ביותר',
  'at The Best Price - Guaranteed!': 'במחיר הטוב ביותר - בהתחייבות!',
  'at The Best Price!': 'במחיר הטוב ביותר!',
  'Best Price Guaranteed!': 'מתחייבים למחיר הזול ביותר!',
  'Travelor - Hotels Worldwide': 'טרוולאור - מלונות בארץ ובעולם - Travelor',
  'Best price guaranteed, Big Savings booking hotels worldwide, up to 75% off on hotel reservations online.':
    'מתחייבים למחיר הנמוך ביותר! חסכון גדול בהזמנת מלונות בארץ ובחו"ל, עד 75% הנחה על הזמנת מלון אונליין.',
  Login: 'התחברות',
  Password: 'סיסמה',
  Logout: 'התנתקות',
  Cancel: 'ביטול',
  Close: 'סגירה',
  'Forgot your password?': 'שכחת את הסיסמה?',
  'Are you sure you want to Logout?': 'האם את/ה בטוח/ה שברצונך להתנתק?',
  'Your Choice': 'הבחירה שלך',
  'The best match': 'ההתאמה הטובה ביותר',
  'Soon...': 'בקרוב...',
  'Oops...': 'אופס...',
  'Please wait...': 'אנא המתן/י...',
  'Connects to a secure server...': 'מתחבר לשרת מאובטח...',
  'Try Again': 'נסה/י שוב',
  'An error has occurred': 'אירעה שגיאה',
  'Your Profile': 'הפרופיל שלך',
  'Your Details': 'הפרטים שלכם',
  'Your Reservation': 'ההזמנה שלכם',
  'Hotels in Israel': 'מלונות בישראל',
  'Hotels in {destination}': 'מלונות ב{destination}',
  'Hotels near {destination}': 'מלונות בסביבת {destination}',
  'Compare hotel prices in {destination}': 'השוואת מחירי מלונות ב{destination}',
  'Compare hotel prices near {destination}':
    'השוואת מחירי מלונות בסביבת {destination}',
  'Searching Hotels in {destination}...': 'מחפש מלונות ב{destination}...',
  'Searching Hotels near {destination}...':
    'מחפש מלונות בסביבת {destination}...',
  'Hotels found in {destination}':
    'לא נמצאו מלונות ב{destination} | מלון אחד נמצא ב{destination} | {count} מלונות נמצאו ב{destination}',
  'Hotels found near {destination}':
    'לא נמצאו מלונות בסביבת {destination} | מלון אחד נמצא בסביבת {destination} | {count} מלונות נמצאו בסביבת {destination}',
  '{count} of {total} hotels found in {destination}':
    'לא נמצאו מלונות ב{destination} | {count} מתוך מלון אחד שנמצא ב{destination} | {count} מתוך {total} מלונות שנמצאו ב{destination}',
  '{count} of {total} hotels found near {destination}':
    'לא נמצאו מלונות בסביבת {destination} | {count} מתוך מלון אחד שנמצא בסביבת {destination} | {count} מתוך {total} מלונות שנמצאו בסביבת {destination}',
  'is initialized': 'בתהליך אישור...',
  'is confirmed': 'מאושרת!',
  'is completed': 'הושלמה!',
  'is cancelled': 'מבוטלת!',
  'is rejected': 'לא אושרה.',
  'is pending-cancellation': 'ממתינה לביטל...',
  'is pending': 'ממתינה לאישור...',
  'is pending-payment': 'ממתינה לתשלום.',
  'Reservation #{id} {status}': 'הזמנה #{id} {status}',
  'Reservation #{id} to the {hotel} {status}': 'הזמנה #{id} ל{hotel} {status}',
  'Dear customer, Your reservation is confirmed! Reservation voucher and receipt will be sent to you in the next few minutes in 2 different emails. For your comfort, your reservation number for contacting our customer service is {number}. At any point and from any reason you can contact us with this email reservations@travelor.com Have a fun vacation!':
    'לקוח יקר, הזמנתך אושרה! שובר הזמנה וקבלה ישלחו אליך בדקות הקרובות ב-2 מיילים נפרדים. לנוחיותך, מספר ההזמנה שלך לצורך פנייה לשירות הלקוחות שלנו הוא {number}. בכל שלב ומכל סיבה ניתן ליצור איתנו קשר בכתובת המייל reservations@travelor.com שתהיה חופשה מהנה!',
  'Dear customer, Your reservation is cancelled. Your reservation number for contacting our customer service is {number}. At any point and from any reason you can contact us with this email reservations@travelor.com':
    'לקוח יקר, הזמנתך בוטלה, לנוחיותך, מספר ההזמנה שלך לצורך פנייה לשירות הלקוחות שלנו הוא <b>{number}</b>. בכל שלב ומכל סיבה ניתן ליצור איתנו קשר בכתובת המייל reservations@travelor.com',
  'Dear customer, Your reservation is being processed but is not approved yet. Please wait for confirmation email. For your comfort, your reservation number for contacting our customer service is {number}. At any point and from any reason you can contact us with this email reservations@travelor.com Have a fun vacation!':
    'לקוח יקר, הזמנתך נמצאת בטיפול, אך אינה מאושרת עדיין. אנא המתן למייל אישור. לנוחיותך, מספר ההזמנה שלך לצורך פנייה לשירות הלקוחות שלנו הוא <b>{number}</b>. בכל שלב ומכל סיבה ניתן ליצור איתנו קשר בכתובת המייל reservations@travelor.com שתהיה חופשה מהנה!',
  'Dear customer, Your reservation to {destination} is confirmed! Reservation voucher and receipt will be sent to you in the next few minutes in 2 different emails. For your comfort, your reservation number for contacting our customer service is {number}. At any point and from any reason you can contact us with this email reservations@travelor.com Have a fun vacation!':
    'לקוח יקר, הזמנתך ל{destination} אושרה! שובר הזמנה וקבלה ישלחו אליך בדקות הקרובות ב-2 מיילים נפרדים. לנוחיותך, מספר ההזמנה שלך לצורך פנייה לשירות הלקוחות שלנו הוא {number}. בכל שלב ומכל סיבה ניתן ליצור איתנו קשר בכתובת המייל reservations@travelor.com שתהיה חופשה מהנה!',
  'Dear customer, Your reservation to {destination} is cancelled. Your reservation number for contacting our customer service is {number}. At any point and from any reason you can contact us with this email reservations@travelor.com':
    'לקוח יקר, הזמנתך ל{destination} בוטלה, לנוחיותך, מספר ההזמנה שלך לצורך פנייה לשירות הלקוחות שלנו הוא <b>{number}</b>. בכל שלב ומכל סיבה ניתן ליצור איתנו קשר בכתובת המייל reservations@travelor.com',
  'Dear customer, Your reservation to {destination} is being processed but is not approved yet. Please wait for confirmation email. For your comfort, your reservation number for contacting our customer service is {number}. At any point and from any reason you can contact us with this email reservations@travelor.com Have a fun vacation!':
    'לקוח יקר, הזמנתך ל{destination} נמצאת בטיפול, אך אינה מאושרת עדיין. אנא המתן למייל אישור. לנוחיותך, מספר ההזמנה שלך לצורך פנייה לשירות הלקוחות שלנו הוא <b>{number}</b>. בכל שלב ומכל סיבה ניתן ליצור איתנו קשר בכתובת המייל reservations@travelor.com שתהיה חופשה מהנה!',
  Search: 'חיפוש',
  OK: 'אישור',
  Destination: 'יעד',
  Rooms: 'חדרים',
  Adults: 'מבוגרים',
  Children: 'ילדים',
  'Children ages': 'גילאי הילדים',
  Room: 'חדר',
  'Add Room': 'הוספת חדר',
  Remove: 'הסרה',
  'Destination or hotel name...': 'יעד או שם מלון...',
  'Select Destination': 'בחרו יעד',
  'Select Dates': 'בחרו תאריכים',
  'Check-in': 'הגעה',
  'Check-out': 'עזיבה',
  1: 'ראשון',
  2: 'שני',
  3: 'שלישי',
  4: 'רביעי',
  'How would you like to pay?': 'איך תרצו לשלם?',
  'How many credit cards will you want to pay?': 'בכמה כרטיסי אשראי תרצו לשלם?',
  'How much would you like to pay on {card} credit card?':
    'כמה תרצו לשלם בכרטיס אשראי ה{card}?',
  '{count} reservations': 'אין הזמנות | הזמנה אחת | {count} הזמנות',
  '{count} cards': ' | כרטיס אשראי אחד | {count} כרטיסי אשראי',
  '{count} nights': ' | לילה אחד | {count} לילות',
  '{count} rooms': 'אין חדרים | חדר אחד | {count} חדרים',
  '{count} hotels': 'אין מלונות | מלון אחד | {count} מלונות',
  '{count} reviews': ' | ביקורת אחת | {count} ביקורות',
  '{count} adults': ' | מבוגר אחד | {count} מבוגרים',
  '{count} children': 'ללא ילדים | ילד אחד | {count} ילדים',
  'Total for {count} nights': ' | סה"כ ללילה אחד | סה"כ ל-{count} לילות',
  '{distance} m from {destination}': "{distance} מ' מ{destination}",
  '{distance} mi from {destination}': '{distance} מייל מ{destination}',
  '{distance} km from {destination}': '{distance} ק"מ מ{destination}',
  'Reservations longer than 30 nights are not possible':
    'מצטערים, לא ניתן לבצע הזמנות שאורכן מעל ל-30 לילות',
  '{count} people are viewing this hotel right now!':
    '{count} אנשים צופים כעת במקום אירוח זה!',
  'Last reservation for this hotel was made {time}.':
    'הזמנה אחרונה למקום אירוח זה בוצעה {time}.',
  Filters: 'מסננים',
  Sort: 'מיון',
  Map: 'מפה',
  List: 'רשימה',
  'Clear filters': 'נקה מסננים',
  'the center': 'המרכז',
  'Show Filters': 'הצג מסננים',
  'Hide Filters': 'הסתר מסננים',
  'Show Results': 'הצג תוצאות',
  'Hide Results': 'הסתר תוצאות',
  'Show Options': 'הצג אפשרויות',
  'Hide Options': 'הסתר אפשרויות',
  'Map View': 'תצוגת מפה',
  'Show on Map': 'הצג על המפה',
  'Close Map': 'סגור מפה',
  'Sort hotels by': 'מיין מלונות לפי',
  'Hotel Name': 'שם מלון',
  'highest first': 'גבוה תחילה',
  'lowest first': 'נמוך תחילה',
  Popularity: 'פופולריות',
  Distance: 'מרחק',
  Price: 'מחיר',
  Stars: 'כוכבים',
  'Property type': 'סוג מקום אירוח',
  apartment: 'דירה',
  hostel: 'אכסניה',
  other: 'אחר',
  hotel: 'מלון',
  Wonderful: 'מעולה',
  'Very Good': 'טוב מאד',
  Good: 'טוב',
  Pleasant: 'נחמד',
  'Guest rating': 'דירוג אורחים',
  'Hotel facilities': 'מתקני מלון',
  'Room facilities': 'מתקני חדר',
  From: 'החל מ-',
  'taxes and charges': 'מיסים וחיובים',
  'Includes VAT': 'כולל מע"מ',
  'VAT not included': 'מע"מ אינו כלול',
  'See Rooms': 'הצג חדרים',
  'Book Now': 'הזמן כעת',
  'Pay Now': 'שלם כעת',
  'Cancellation Policy': 'תנאי הביטול',
  refundable: 'ניתן לביטול',
  'fully-refundable': 'ביטול חינם',
  'non-refundable': 'לא ניתן לביטול',
  nonrefundable: 'לא ניתן לביטול',
  'Refundable until {date}': '<b>ניתן לביטול</b> עד {date}',
  'Useable until {date}': '<b>ניתן למימוש</b> עד {date}',
  'Refundable before {date}': '<b>ניתן לביטול</b> לפני {date}',
  'From {date} non refundable': 'מ-{date} <b>לא ניתן לביטול</b>',
  'Free cancellation before {date}': '<b>ביטול חינם</b> לפני {date}',
  'I want to receive copy of voucher to e-mail {email}.':
    'אני מעוניין לקבל העתק של השובר למייל <b>{email}</b>.',
  'I want to receive the voucher to e-mail {email}.':
    'אני מעוניין לקבל את השובר למייל {email}.',
  RO: 'לינה בלבד',
  BB: 'לינה וארוחת בוקר',
  CB: 'לינה וארוחת בוקר קונטיננטלית',
  HB: 'חצי פנסיון',
  FB: 'פנסיון מלא',
  AI: 'הכל כלול',
  Twin: 'מיטת יחיד',
  King: 'מיטת קינג',
  Queen: 'מיטת קווין',
  Double: 'מיטה זוגית',
  double: 'זוגי',
  quadruple: 'רביעייה',
  '1 Twin Bed': 'מיטת יחיד',
  '1 King Bed': 'מיטת קינג',
  '1 Queen Bed': 'מיטת קווין',
  '1 Double Bed': 'מיטה זוגית',
  '2 Twin Beds': '2 מיטות יחיד',
  '2 King Beds': '2 מיטות קינג',
  '2 Queen Beds': '2 מיטות קווין',
  '2 Double Beds': '2 מיטות זוגיות',
  '3 Twin Beds': '3 מיטות יחיד',
  '1 King Bed and 1 Twin Bed': 'מיטת קינג ומיטת יחיד',
  '1 King Bed and 1 Queen Bed': 'מיטת קינג ומיטת קווין',
  '1 King Bed and 1 Double Bed': 'מיטת קינג ומיטה זוגית',
  '1 King Bed and 1 Double Sofa Bed': 'מיטת קינג ומיטת ספה זוגית',
  '1 King Bed or 2 Twin Beds': 'מיטת קינג או 2 מיטות יחיד',
  '1 King Bed and 2 Twin Bunk Beds': 'מיטת קינג ו-2 מיטות יחיד קומותיים',
  '2 Twin Beds or 1 King Bed': '2 מיטות יחיד או מיטת קינג אחת',
  '2 Double Beds or 1 King Bed': '2 מיטות זוגיות או מיטת קינג אחת',
  '2 Queen Beds and 2 Twin Beds': 'מיטת קינג ו-2 מיטות יחיד קומותיים',
  'Room Size': 'גודל החדר',
  'Free Wifi': 'אינטרנט אלחוטי חינם',
  'Non Smoking': 'ללא עישון',
  'No rooms matched your filter': 'לא נמצאו חדרים התואמים את הסינון שלך',
  "Notice! Most hotels don't have rooms for over 4 people. If you are not getting any results, please make a new search choosing 2 rooms (or more).":
    'שים לב! ברוב המלונות אין חדרים המתאימים להרכב של מעל 4 אנשים. אם אינך רואה תוצאות, יש לבצע שוב את החיפוש ולחלק את הרכב האנשים ל-2 חדרים (או יותר).',
  'No results matched your search': 'לא נמצאו תוצאות התואמות את החיפוש שלך',
  'This offer has expired': 'פג תוקפה של הצעה זו',
  'Only English': 'אנגלית בלבד',
  'First Name': 'שם פרטי',
  'Last Name': 'שם משפחה',
  'E-Mail Address': 'כתובת דוא"ל',
  'Customer E-Mail Address': 'כתובת דוא"ל של הלקוח',
  'Confirm E-Mail Address': 'אימות כתובת דוא"ל',
  'Confirm Customer E-Mail Address': 'אימות כתובת דוא"ל של הלקוח',
  'Attention!': 'שימו לב!',
  'The rate presented is for {country} citizens only.':
    'התעריף המוצג הינו לאזרחי {country} בלבד.',
  'Change the rate for {country} citizens': 'שנה תעריף לאזרחי {country}',
  'I am a citizen of {country}': 'אני אזרח {country}',
  Citizenship: 'אזרחות',
  Prefix: 'קידומת',
  'Phone Number': "מס' טלפון",
  'Card Number': "מס' כרטיס",
  'Cancellation fee': 'דמי ביטול',
  'Cannot be more then total price': 'הסכום לא יכול להיות גבוה ממחיר ההזמנה',
  'Add additional commission': 'הוספת עמלה נוספת',
  '{percent}% will be deducted from the added commission.':
    '{percent}% ינוכו מהעמלה הנוספת.',
  '{percent}% will be deducted from the cancellation fee.':
    '{percent}% ינוכו מדמי הביטול.',
  'I want to set cancellation fee': 'אני מעונין להגדיר דמי ביטול',
  'Please note! It is possible that the accommodation will collect additional charges (city tax, resort fee, etc.) in accordance with its policy which will be paid directly to the accommodation.':
    'לתשומת ליבך! ייתכן ומקום האירוח יגבה חיובים נוספים (מס עירוני, היטל נופש וכדו׳) בהתאם למדיניותו אשר ישולמו ישירות למקום האירוח.',
  'I agree to the': 'אני מאשר את',
  'remarks & cancellation policy': 'ההערות ותנאי הביטול',
  'Remarks & Cancellation policy': 'ההערות ותנאי הביטול',
  'I want to receive promotional offers in the future.':
    'אני מעוניין לקבל הצעות ומבצעים בעתיד.',
  'Continue to Payment': 'המשך לתשלום',
  'Secure Booking': 'הזמנה מאובטחת',
  Home: 'ראשי',
  Company: 'חברה',
  About: 'אודות',
  'lang/about': 'he/אודות',
  'Contact Us': 'צור קשר',
  'lang/contact': 'he/צור-קשר',
  Testimonials: 'לקוחות ממליצים',
  'lang/testimonials': 'en/testimonials',
  FAQ: 'שאלות נפוצות',
  'lang/faq': 'he/שאלות-נפוצות',
  'Terms & Conditions': 'תנאי השימוש',
  'Agent Terms & Conditions': 'תנאי השימוש לסוכן',
  'lang/terms': 'he/תנאי-שימוש',
  'Privacy & Cookie Statement': 'הצהרת פרטיות וקבצי עוגיות',
  'lang/privacy': 'he/מדיניות-פרטיות',
  'Best Price Guaranteed': 'מתחייבים למחיר הזול ביותר',
  'lang/best-price-guaranteed': 'he/מתחייבים-למחיר-הזול-ביותר',
  Services: 'שירותים',
  Hotels: 'מלונות',
  Packages: 'חבילות',
  Tickets: 'כרטיסים',
  Flights: 'טיסות',
  'Car Rentals': 'השכרת רכב',
  'Travel Insurance': 'ביטוח נסיעות',
  'Currency Exchange': 'המרת מטבע',
  'Join as an Agent': 'הצטרף כסוכן',
  Continents: 'יבשות',
  Places: 'מקומות',
  Destinations: 'יעדים',
  Asia: 'אסיה',
  Africa: 'אפריקה',
  'North America': 'אמריקה הצפונית',
  'South America': 'אמריקה הדרומית',
  Antarctica: 'אנטארקטיקה',
  Europe: 'אירופה',
  Oceania: 'אוקיאניה',
  Dark: 'כהה',
  Light: 'בהיר',
  System: 'מערכת',
  Reviews: 'ביקורות',
  'Reservations pending payment': 'הזמנות הממתינות לתשלום',
  'View receipt': 'צפייה בקבלה',
  'Send request to hotel': 'שליחת בקשה למלון',
  'Edit request to hotel': 'עריכת הבקשה',
  'View your HCN': 'צפיה ב-HCN',
  'Send voucher': 'שליחת שובר',
  'Enter email address': 'הזן כתובת אימייל',
  Send: 'שליחה',
  Reference: 'קוד אישור הזמנה',
  Pay: 'תשלום',
  'Enter your request': 'הזן את הבקשה שלך',
  Language: 'שפה',
  Currency: 'מטבע',
  'Price display': 'תצוגת מחיר',
  'Net price (no commission)': 'מחיר נטו (ללא עמלה)',
  'Gross price (including commission)': 'מחיר ברוטו (כולל עמלה)',
  'Base price': 'מחיר בסיסי',
  'Price includes taxes & charges': 'מחיר כולל מיסים וחיובים',
  'Popular currencies': 'מטבעות פופולריים',
  'All currencies': 'כל סוגי המטבעות',
  'Great choice of property': 'בחירה מעולה של מקום אירוח',
  'Sending a special request to the hotel': 'שליחת בקשה מיוחדת למלון',
  'Special requests are sent to the hotel and there are no commitments to be fulfilled':
    'בקשות מיוחדות נשלחות למלון ואין באחריותינו שימולאו',
  // 'According to your search, you can not select more than {rooms} rooms': 'על פי החיפוש שהזנת, אין באפשרותך לבחור יותר מ{rooms} חדרים',
  'This offer will expire in {minutes} minutes {seconds} seconds':
    'הצעה זו תפוג בעוד {seconds} שניות | הצעה זו תפוג בעוד דקה אחת ו-{seconds} שניות | הצעה זו תפוג בעוד {minutes} דקות ו-{seconds} שניות',
  'Please select a reason': 'נא לבחור סיבה',
  'Please enter a name': 'הזן שם',
  'Please select a refund option': 'נא לבחור אמצעי החזרה',
  'Please enter a first name': 'הזן שם פרטי',
  'Please enter a last name': 'הזן שם משפחה',
  'Please enter an email address': 'הזן כתובת דוא"ל',
  'Please enter a valid email address': 'הזן כתובת דוא"ל נכונה',
  'Please enter a phone': 'הזן טלפון',
  'The email confirmation does not match': 'אימות דוא"ל אינו תקין',
  'Please enter only English characters': 'אנא הזן אותיות באנגלית בלבד',
  'Book now, Pay later': 'הזמן כעת, שלם מאוחר יותר',
  'Refresh Results': 'רענן תוצאות',
  'Go To Home Page': 'חזרה לדף הבית',
  'Agent ID': 'מזהה סוכן',
  'NEW!': 'חדש!',
  'Recommended!': 'מומלץ!',
  'Customer Details': 'פרטי הלקוח',
  'Payer Details': 'פרטי המשלם',
  'Secure Payment': 'תשלום מאובטח',
  'Hotel Details': 'פרטי המלון',
  'Rooms and Guests Details': 'פרטי החדרים והאורחים',
  'Of the lead guest in this room': 'של האורח העיקרי בחדר זה',
  'Confirmation email sent to this address': 'אישור ההזמנה ישלח לכתובת זו',
  'For updates regarding your reservation': 'לעדכונים בנוגע להזמנתכם',
  'Translate to {locale}': 'תרגם ל{locale}',
  'Translated from {source} by': 'תורגם מ{source} על-ידי',
  'Show source': 'הצג מקור',
  'Tax invoice': 'חשבונית מס',
  'Edit Tax invoice': 'עדכון פרטי חשבונית מס',
  'Name on Invoice': 'שם לחשבונית',
  'Name on Receipt': 'קבלה על שם',
  'Business name': 'שם עסק',
  'VAT Number': 'ת.ז. / ח.פ.',
  'I want to receive tax invoice.': 'אני מעוניין לקבל חשבונית מס.',
  'A tax invoice will be sent on the check-out day.':
    'חשבונית מס תישלח עד 14 יום מיום העזיבה',
  'A receipt will be sent to this email address': 'קבלה תשלח לכתובת דוא"ל זו',
  "Travelor's banks details": 'פרטי חשבונות בנק להעברה',
  Leumi: 'לאומי',
  Poalim: 'פועלים',
  'Bank number': 'מספר בנק',
  'Branch number': 'מספר סניף',
  'Account number': 'מספר חשבון',
  'Account name': 'שם החשבון',
  'V. Travelor LTD': 'וי. טרוולאור בע"מ',
  'Bank Transfer Details': 'פרטי העברה',
  'Date transfer': 'תאריך העברה',
  'Amount for this reservation': 'סכום עבור הזמנה זו',
  Name: 'שם',
  "Bank account holder's name": 'שם בעל החשבון',
  'Which the transfer was made from': 'ממנו התבצעה ההעברה',
  'Total amount': 'סכום העברה',
  'The total amount of the transfer': 'סך כל הסכום שהועבר',
  'From the total amount': 'מתוך הסכום שהועבר',
  'The payment receipt confirmation will be updated in the order management page within 2 business days. The update will appear in "Received Payments" under the "Bank Transfer" payment type.':
    'אישור קבלת התשלום יעודכן בעמוד ניהול ההזמנה בתוך שני ימי עסקים. העדכון יופיע תחת "תשלומים שהתקבלו" בסוג התשלום "העברה בנקאית".',
  Bank: 'בנק',
  'The bank from which the transfer was received': 'הבנק ממנו התבצעה ההעברה',
  'Receipt type': 'אופן הפקת הקבלה',
  'One receipt for all reservations': 'קבלה אחת עבור כל ההזמנות',
  'A separate receipt for each reservation': 'קבלה נפרדת לכל הזמנה',
  'Travelor Bank': 'חשבון בנק טרוולאור',
  'Transfer type': 'סוג העברה',
  Regular: 'העברה רגילה',
  RTGS: 'העברת זה״ב',
  'Upload transfer confirmation document':
    'אסמכתא (צילום מסך או מסמך אישור העברה)',
  Remarks: 'הערות',
  Confirm: 'אישור',
  en: 'אנגלית',
  Sum: 'סכום',
  Value: 'ערך',
  'Cancel reservation': 'ביטול הזמנה',
  'Cancel reservation with 100% cancellation fee':
    'ביטול הזמנה עם 100% דמי ביטול',
  'I confirm the cancellation of the reservation with 100% cancellation fees.':
    'אני מאשר את ביטול ההזמנה עם 100% דמי ביטול.',
  'Please accept': 'נא לאשר',
  'Reservation {id}': 'הזמנה {id}',
  'Love helping your friends book vacations?':
    'אוהבים לעזור לחברים לסגור חופשות?',
  "Let's make money from it!": 'בואו להרוויח מזה כסף!',
  'By clicking on the button I agree to receive occasional emails. We hate spam and we will never give away your details.':
    'ע"י לחיצה על הכפתור אני מסכים לקבל דיוור מטרוולאור מפעם לפעם, אנו שונאים ספאם לעולם לא נעביר את פרטיך לאיש.',
  'Payment reservation {id}': 'תשלום הזמנה {id}',
  // 'The information and images about the hotels presented on the website are supplied by the hotels and suppliers we are working with. Travelor does not oblige to the credibility and accuracy of the information.': 'המידע והתמונות אודות המלונות המופיעים באתר מגיעים מבתי המלון והספקים הרבים שעובדים איתנו. טרוולאור אינה מתחייבת לאמינות ודיוק מידע זה.',
  "I confirm reading, understanding and updating the customer with all the reservation details. Including hotel information, board basis, dates, compositions, room type, cancelation, payment details, room notes, taxes and additional charges that may be charged by the hotel, and I'm fully responsible for this reservation.  If it turns out that the information I gave my customer was missing or incorrect, I understand that the implications (if will be) are my responsibility only.":
    'אני מאשר שקראתי את כל פרטי העסקה והעברתי ללקוח את כל הנתונים, לרבות פרטי המלון, בסיס האירוח, תאריכים, הרכבים, סוג החדר, תנאי הביטול, תנאי התשלום, הערות לכל חדר ותשלומים נוספים שייתכן שיחויב ישירות במלון, ואני לוקח אחריות מלאה על הזמנה זו. אם יתברר שהמידע שמסרתי ללקוח היה חסר או מוטעה, אני מבין שההשלכות כתוצאה מכך (אם יהיו) הן על אחריותי בלבד.',
  'Copyright © {year} {brand}. all rights reserved.':
    'זכויות יוצרים © {year} {brand}. כל הזכויות שמורות',
  'Add to quote': 'הוסף להצעת מחיר',
  'Customer information': 'פרטי לקוח',
  'Add New Customer': 'הוסף לקוח חדש',
  'Quote information': 'פרטי הצעת מחיר',
  'Quote Name': 'שם הצעת מחיר',
  Probability: 'רמת רצינות',
  low: 'נמוכה',
  medium: 'בינונית',
  high: 'גבוהה',
  very_high: 'גבוהה מאוד',
  'Valid until': 'תקף עד',
  'Add Comments': 'הוסף הערות',
  'Comment for internal use': 'הערה לשימוש פנימי',
  'Comment for customer': 'הערה ללקוח',
  'Create Quote': 'צור הצעת מחיר',
  'Add Customer': 'הוסף לקוח',
  'Create Customer': 'צור לקוח',
  'Select Customer': 'בחר לקוח',
  'This field is required': 'שדה חובה',
  'Success! Your quote is now ready.': 'הצלחה! הצעת המחיר שלך מוכנה כעת.',
  'Copied!': 'הועתק!',
  'Copy link': 'העתק קישור',
  'View your quote': 'צפה בהצעת המחיר שלך',
  'Add To Cart': 'הוסף לסל',
  'Add to cart': 'הוסף לסל',
  "Item successfully added to {name}'s cart!":
    'הפריט נוסף בהצלחה לעגלת הקניות של {name}!',
  "View {name}'s Cart": 'צפה בעגלת הקניות של {name}',
  'Customer identification': 'זיהוי לקוח',
  directFlight: 'טיסה ישירה',
  oneStop: 'עצירה אחת',
  twoStops: 'עצירות שתי',
  'Flight Details': 'פרטי טיסה',
  'Passenger Details': 'פרטי נוסעים',
  'Passenger {index}': 'נוסע {index}',
  'Car Details': 'פרטי רכב',
  'Ticket Details': 'פרטי כרטיס',
  'Package Details': 'פרטי חבילה',
  'or similar': 'או דומה',
  Pickup: 'איסוף',
  at: 'ב',
  '{num} seats': '{num} מושבים',
  automatic: 'אוטומטי',
  manual: 'ידני',
  unknown: 'לא ידוע',
  '{num} large bag': '{num} מזוודה גדולה',
  '{num} small bag': '{num} מזוודה קטנה',
  'Room {idx}': 'חדר {idx}',
  'Room Type': 'סוג חדר',
  Board: 'פנסיון',
  Guests: 'אורחים',
  Babies: 'תינוקות',
  Seniors: 'פנסיונרים',
  Students: 'סטודנטים',
  Youth: 'צעירים',
  Outbound: 'טיסת הלוך',
  Inbound: 'טיסת חזור',
  Adult: 'מבוגר',
  Child: 'ילד',
  Infant: 'תינוק',
  Senior: 'פנסיונר',
  Student: 'סטודנט',
  Date: 'תאריך',
  Location: 'מיקום',
  Seats: 'מושבים',
  Quantity: 'כמות',
  'Pick-up': 'איסוף',
  'Drop-off': 'החזרה',
  'Passport expiry date': 'תוקף דרכון',
  'Passport number': 'מספר דרכון',
  'Date of birth': 'תאריך לידה',
  Baggage: 'כבודה',
  'flight section': 'קטע טיסה',
  'Rental company': 'חברת השכרה',
  'To select a seat or add baggage press here':
    'לבחירת מושב או הוספת כבודה לחץ כאן',
  'Flight no.': 'מספר טיסה',
  'Passenger Type': 'סוג נוסע',
  'Date Change': 'שינוי תאריכים',
  'The payment has been successfully processed!': 'התשלום נקלט בהצלחה!',
  'This page will redirect shortly, Please wait or click "Continue"':
    'עמוד זה יבצע הפניה מחדש, אנא המתן או לחץ על "המשך"',
  Continue: 'המשך',
}
